




























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { DownloadFileQueryDto } from '@/@types/File';
import { vxm } from '@/store';

@Component({
  components: {
    AccountIcon,
  },
})
export default class ShowFilePreviewModal extends Vue {
  @Prop({ required: true })
  private isShowFilePreviewModal!: boolean;
  @Prop({ required: true })
  private fileId!: number;
  @Prop({ required: true })
  private fileName!: string;
  private url: string = '';

  private framescrolling: string = 'no';
  private frameBorder: number = 0;

  private async created() {
    const query: DownloadFileQueryDto = {
      'project-id': vxm.theoryApi.authStore.getCurrentProjectId,
    };
    await vxm.theoryApi.filesStore.fetchDownloadUrl({
      fileId: this.fileId,
      query: query,
    });
    const response = vxm.theoryApi.filesStore.getDownloadUrl;
    if (response) {
      this.url = response.results.signedUrl;
    }
  }

  private getExtension() {
    const startIndex = this.fileName.lastIndexOf('.');
    if (startIndex === -1) {
      return '';
    }
    return this.fileName.slice(startIndex + 1);
  }

  private getMediaType() {
    const extension = this.getExtension();
    if (extension === 'png') {
      return 'image';
    } else if (extension === 'xlsx' || extension === 'pdf') {
      return 'document';
    } else return '';
  }

  private async download() {
    const query: DownloadFileQueryDto = {
      'project-id': vxm.theoryApi.authStore.getCurrentProjectId,
    }
    await vxm.theoryApi.filesStore.fetchDownloadUrl({ fileId: this.fileId, query: query });
    const response = vxm.theoryApi.filesStore.getDownloadUrl;
    if (response) {
      const downloadLink = document.createElement('a');
      downloadLink.download = this.fileName;
      downloadLink.href = response.results.signedUrl;
      downloadLink.click();
    }
  }

  @Emit('closeShowFilePreviewModal')
  private emitShowFilePreviewModal() {
    return;
  }
}
